import 'mdn-polyfills/String.prototype.endsWith';

export class KeycloakConfig {
  static config = () => {
    let url = 'https://openid.dev.elotech.com.br/auth';

    if (window.location.host.endsWith('qa.elotech.com.br')) {
      url = 'https://openid.qa.elotech.com.br/auth';
    } else if (window.location.host.endsWith('oxy.elotech.com.br')) {
      url = 'https://openid.oxy.elotech.com.br/auth';
    }

    return {
      realm: 'OxyElotech',
      url,
      resource: 'protocolo-frontend',
      clientId: 'protocolo-frontend',
      'ssl-required': 'external',
      'public-client': true,
      'confidential-port': 0,
      'enable-cors': true
    };
  };
}
